//Import css
import "./Pages.css"
import React, {useEffect, useState} from "react";
import {Formik, Form, Field, ErrorMessage} from 'formik' ;
import { Image,
  useBreakpointValue,
  Alert,
  AlertIcon,
  Slide,
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Text,
  Heading,
  Input,
  Select,
  Textarea,
  VStack, Center
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faArrowRight, faMoon, faSun} from "@fortawesome/free-solid-svg-icons"
import benLogo from "../Assets/Ben-Asenso-logo-white.png"
import {useSpring , animated } from "react-spring";
import { useInView } from "react-intersection-observer";
import * as Yup from "yup";

import app from "../Components/firebase";
import { getFirestore } from "firebase/firestore";
import {collection, addDoc} from 'firebase/firestore';
import {getDatabase, ref, onValue} from "firebase/database"
import { assets, workData } from "../AssetsPort/assets";
import ReCAPTCHA from 'react-google-recaptcha'
import {motion} from "motion/react"
import { useLocation } from "react-router-dom";
import "typeface-ovo"
import axios from "axios";


function ContactMeSection({toggleProp, toggleHandler, setToggle, setSelected}){

  //let [toggle, settoggle] = useState(false) // Creating a switch to toggle theme
  let [alertMessage, setAlertmessage] = useState("")
  let [alerterrormessage, setalerterrormessage] = useState("")

  let [online, setOnline] = useState(navigator.onLine)
  let [isOpen, setIsOpen] = useState(false)
  let [offlineMessage, setOfflineMessage] = useState(false)

  let location= useLocation()

  let dataB = getFirestore(app)
  let database = getDatabase(app)
  

  let onClose = ()=> {
    setIsOpen(true)
    setAlertmessage("")
  }

  let onClose2= ()=> {
    setalerterrormessage("")
  }

  //Setting the initial value for the input fields
  let initialValues = {
    name: "",
    email: "",
    message: "",
    enquiry: "Freelance Project",
    recaptcha: "",
  }

  //Setting the rules for validation for the input fields
  let validationSchema = Yup.object({
    name:Yup.string().required("Name is Required"),
    email:Yup.string().email("Invalid email format").required("Email is required"),
    message: Yup.string().required("Your message is required").min(25, "Minimum characters is 25"),
    enquiry: Yup.string(),
    recaptcha: Yup.string().required("Recaptcha is required")
  })


  let verifyCaptcha = async(token, formik)=>{
    // if the key and value have the same name you can simple represent it as eg. {token}
    try{
      let response = await axios.post("https://api-qeka.onrender.com/api/verifycaptcha/", {token}, {
        headers:{
        'X-CSRFToken': csrftoken
        }
      })
      console.log("Captcha token sent successfully", response)
      formik.setFieldValue("recaptcha", token)
    }
    catch (error){
      console.error("Error sending captcha token", error)
      formik.setFieldValue("recaptcha", "")
    }
  }

  // Function to suppose to get django default csrf_token from cookie in browser when React is served on django
  function getCSRFToken(){
    let cookieValue = document.cookie.match(/csrftoken=([^ ;]+)/)
    return cookieValue ? cookieValue[1] : null
  }

  let csrftoken = getCSRFToken();
  

  
  // useEffect((e)=>{
  //   let connectionStatus = ref(database, ".info/connected")

  //   // onValue means keep an eye on the connection status, if it changes let me know and give me a picture/snapshot of it.
  //   let connectionStatusListener = onValue(connectionStatus, (snapshot)=>{
  //     setOnline(snapshot.val())
  //   })
  //   return()=>{
  //     connectionStatusListener()
  //   }
  // }, [])

  useEffect((e)=>{
    let func = ()=>{
      setOnline(navigator.onLine)
    }
    window.addEventListener("online", func)
    window.addEventListener("offline", func)
    return()=>{
      window.removeEventListener("online", func)
      window.removeEventListener("offline", func)
    }
  }, [])


  
  let [result, setResult] = useState()

  const onSubmit = async (values, actions) => {
    if(online){
    setResult("Sending....")
    const formData = new FormData();

    formData.append("access_key", "9d07ec7f-afc4-4c3d-a5d5-4f8f8168dec4");
    formData.append("name", values.name)
    formData.append("email", values.email)
    formData.append("message", values.message)
    formData.append("enquiry", values.enquiry)
    try{
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData
      })
      setAlertmessage(`Thanks for your submission ${values.name}, we'll get back to you shortly!`)
      actions.resetForm()

      // const data = await response.json();
      // if (data.success) {
      //   setResult("Form Submitted Successfully");
      //   //event.target.reset();
      // } else {
      //   console.log("Error", data);
      //   setResult(data.message);
      // }
    }
    catch(error){
      console.error("Error submitting form:", error)
      setalerterrormessage("Error submitting form")
    }

  }
  else{
    setIsOpen(true)
    setOfflineMessage(true)  
    setTimeout(() => {
      setOfflineMessage(false)
    }, 5000); 
  }

  };
  
  
  //Setting the onSubmit handler event upon clicking submit
  // the values are the values the user typed, "setSubmitting(false)" is Formik way of saying the form submission is complete
//   let onSubmit = async (values, actions) => {

//     setTimeout((e)=>{
//       actions.setSubmitting(false)
//     }, 30000)


//   if(online){

//   try{
//     let formsCollection = collection(dataB, "contactForms")
//     await addDoc(formsCollection, values)   
//     setAlertmessage(`Thanks for your submission ${values.name}, we'll get back to you shortly!`)
//     actions.resetForm()
//   }

//   catch (error){
//     setalerterrormessage("Error submitting form")
//     console.error("Error submitting form:", error.message)

//   }

// }

// else{
//   setIsOpen(true)
//   setOfflineMessage(true)  
  
//   setTimeout(() => {
//     setOfflineMessage(false)
//   }, 5000);
// }

//   actions.setSubmitting(true)
//   //I'm wrapping setTimeout around console.log and co. here bcos i want to create illusion of a loading sign.  
//   setTimeout((e) => {
//     console.log("Form Data:", values)

//     }, 500)

// } 

let [visible, setVisible] = useState(false)
let {ref: ref1, inView: inView1} = useInView({triggerOnce: true})
//let {ref :ref6, inView:inView6} = useInView({triggerOnce: true})
// useInview for contactView
let {ref: refContact, inView: inViewContact} = useInView({triggerOnce: false})


let animation = useSpring({
  opacity: visible? 1: 0,
  transform: visible? "translateY(0px)": "translateY(100px)",
  config: {tension: 200, friction: 20,duration: 1000}
})


useEffect((e)=>{
  if (inView1){
    setVisible(true)
  }
}, [inView1])

useEffect((e)=>{
  if (inViewContact){
    setSelected("Contact")
  }
}, [inViewContact])





let mobileView = useBreakpointValue({
  base: true,
  md: false
})

  
  return(
    <div>
        <VStack backgroundImage={assets.footer_bg} backgroundSize="cover" backgroundPosition="center" maxWidth="full" spacing={8} bg={toggleProp? "#11001f":""} color={toggleProp? "white":"gray.700"} ref={refContact}>
           
           <Box >
            <Center px={10} pt={10} >
            <VStack>
            <motion.h4 initial={{y:-20, opacity:0}} whileInView={{y:0, opacity: 1}} transition={{duration: 0.5, delay:0.3}} className="text-lg font-ovo">Connect with me</motion.h4>
            <div style={{position:"relative"}}>
            <motion.div initial={{y:-20, opacity:0}} whileInView={{y:0, opacity: 1}} transition={{duration: 0.5, delay:0.5}} >
            {/* <Heading as="h2"size="2xl" id="contact" >Get in touch</Heading> */}
            <h2 id="contact" className="font-ovo text-5xl"  style={{position:"relative", zIndex:10}}>Get in touch</h2>

              <div style={{position:"relative"}}></div>
              <div style={{position:"absolute", top:"0%", right:"-10%", zIndex:0, display:toggleProp? "block":"none", pointerEvents:"none"}}>
              <img src={assets.theme_pattern} className="w-36" />      
              </div>
            </motion.div>
            </div>
            <motion.p initial={{opacity:0}} whileInView={{opacity: 1}} transition={{duration: 0.5, delay:0.7}}  className="text-center font-ovo max-w-2xl mx-auto mt-3 mb-10">
              I'd love to hear from you! If you have any questions, comments or feedback,
              please use the form below.  Whether you're ready to kick off a project or just want to explore possibilities, get in touch to discuss your project ideas or collaboration opportunities. 
            </motion.p>
            </VStack>
            </Center>

            {/* <Text fontSize="xl" paddingLeft={10} paddingRight={10} style={{margin: 5, paddingTop: 20,}}></Text> */}
            </Box>


            
            <Box width="full" className="mx-auto max-w-3xl" paddingLeft={mobileView? 10:20} paddingRight={mobileView? 10:20} paddingBottom={20}>

            {/* <animated.div style={animation} ref={ref1}> */}
            {/* Nothing should interfere the 3F's thhat is Formik, (formik) sub and Form. 
            Also sunmit button dont need onsubmit because it's part of the form*/ }

            <Formik 
              onSubmit = {onSubmit}
              initialValues = {initialValues}
              validationSchema ={validationSchema}>  
     
                {(formik) => (
               
                <motion.div initial={{opacity:0}} whileInView={{opacity:1}} transition={{duration:0.5, delay:0.9}}>
                <Form >
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
                  <FormControl isInvalid = {!!formik.errors.name && formik.touched.name} maxW="full" >
                      <motion.div initial={{x:-50, opacity:0}} whileInView={{x:0, opacity:1}} transition={{delay:1.1, duration: 0.6}}>
                    <FormLabel htmlFor="name">Name</FormLabel>
                    <Field as={Input} type="text" id="name" name="name" bg={toggleProp? "#11002f":"white"} color={toggleProp? "white":"gray.700"} placeholder="Enter your name" />
                  <FormErrorMessage>
                  <ErrorMessage name="name"/>
                  </FormErrorMessage>
                      </motion.div>
                  </FormControl>
                    
                    {/*From the right */}
                  <FormControl isInvalid= {!!formik.errors.email && formik.touched.email} >
                        <motion.div initial={{x:50, opacity:0}} whileInView={{x:0, opacity:1}} transition={{delay:1.2, duration: 0.6}}>
                      <FormLabel htmlFor="email">Email Address</FormLabel>
                      <Field as={Input} name="email" type="email" id="email" bg={toggleProp? "#11002f":"white"}  color={toggleProp? "white":"gray.700"} placeholder="Enter your email address" />
                      <FormErrorMessage>
                      <ErrorMessage name="email"/>
                      </FormErrorMessage>
                        </motion.div>
                  </FormControl>

                  <FormControl >
                      <motion.div initial={{x:-50, opacity:0}} whileInView={{x:0, opacity:1}} transition={{delay:1.3, duration: 0.6}}>
                    <FormLabel htmlFor="select" >Type of Enquiry</FormLabel>
                    <Field as={Select} name="enquiry" id="select" bg={toggleProp? "#11002f":"white"}   color={toggleProp? "white":"gray.700"} >
                      <option style={{background:toggleProp&& "#11002f"}} className={`${toggleProp? "text-white":"text-gray.700"}`}>Freelance Project</option>
                      <option style={{background:toggleProp&& "#11002f"}} className={`${toggleProp? "text-white":"text-gray.700"}`}>Open Consultation Session</option>
                      <option style={{background:toggleProp&& "#11002f"}} className={`${toggleProp? "text-white":"text-gray.700"}`}>Other</option>
                    </Field>
                      </motion.div>
                  </FormControl>
                  </div>

                  <FormControl isInvalid = {!!formik.errors.message && formik.touched.message} mt={4} mb={2}>
                      <motion.div initial={{y:100, opacity:0}} whileInView={{y:0, opacity:1}} transition={{delay:1.4, duration: 0.6}}>
                    <FormLabel htmlFor="message">Your message</FormLabel>
                    <Field as={Textarea} name="message" id="message" bg={toggleProp? "#11002f":"white"}  color={toggleProp? "white":"gray.700"} minHeight={250} placeholder="Tell us about your project or message" />
                    <FormErrorMessage>
                    <ErrorMessage name= "message"/>
                    </FormErrorMessage>
                      </motion.div>
                  </FormControl>
                  
               
                  {/*Google ReCaptcha*/}  {/*Prevents brute-force attacks on user accounts. Email verification protects the signup from bots activating accounts even if they submit fake sign-ups */}     
                  {online ?   // The backslash(\) is use to escape the forward slash(/), 0therwise syntax erorr. Basically tell regex engine to include the forward slash(/). The ? makes (signin) optional allowing / to match too
                    <div style={{maxHeight:"78px", overflow:"hidden", margin:"auto", width:"304px", transform:"scale(0.80)", transition:"opacity 0.3s", background:toggleProp? "#181818":"white", borderRadius:10}} >
                    <Center>
                    <ReCAPTCHA sitekey="6Lc2uZIqAAAAAFhXwPGr9Wvt1qRHi7Oznfba5ZHV" theme={toggleProp? "dark":"light"} onChange={(token)=>{
                      console.log("ReCatpcha token here:", token) 
                      verifyCaptcha(token, formik)
                    }} 
                    onErrored={()=>console.error("Capcha error")}   onExpired={(e)=> console.warn("reCAPCTHA expired. Refresh")}
                    />            
                    </Center>
                    </div>
                    : <p style={{color:"#e53e3e", fontSize:"14px"}}>Please check your internet connection</p>}


                    {(formik.errors.recaptcha&&formik.touched.recaptcha)? <p style={{color:"#e53e3e", fontSize:"14px", marginTop:10}}>ReCaptcha is required</p> :""}

                  
                  <Center>
                    <motion.div whileHover={{scale:1.05, duration:0.3}}>
                  <Button type="submit" mt={2} rightIcon={<FontAwesomeIcon icon={faArrowRight} />} loadingText="Sending..." width={mobileView&& "full"} px={8} py={6} borderRadius="50px" color="white" bg={toggleProp? "linear-gradient(264deg, #DF8908 -5.09%, #B415FF 106.28%)": "#111827"} _hover={{background: toggleProp? " linear-gradient(164deg, #DF8908 -5.09%, #B415FF 106.28%)":"#030712"}} _focus={{boxShadow: toggleProp? `0 0 0 4px black, 0 0 0 8px white`:`0 0 0 4px white, 0 0 0 8px black`}} isLoading={formik.isSubmitting}>Submit now</Button>
                    </motion.div>
                  </Center>
                </Form>
                </motion.div>
               )}
            </Formik>
                                        {/* The {formik.isSubmitting} is a true or false/property provided by formik that indicates whether the form is currently being submitted. That's why i have to delay the onSubmit*/}

            <div className="text-center mt-20">
              {/* <img src={toggleProp? assets.logo_dark:assets.logo} alt="" className="w-36 mx-auto mb-2" /> */}
              <Image className="mx-auto mb-2" src={benLogo} style={{filter:!toggleProp? "invert(100%)":""}} alt="Ben Asenso logo" title="Ben Asenso Web Developer and Digital Marketing Freelancer" width={240} /> 
              <div className="w-max flex items-center gap-2 mx-auto">
                <img src={toggleProp? assets.mail_icon_dark:assets.mail_icon} alt="" className="w-6" />
                ben@benasenso.com
              </div>

               
            </div>

            </Box>

            <AlertDialog
            isOpen={alertMessage}  /* What will make it open is the alertMessage variable*/
            onClose={onClose}
            preserveScrollBarGap
            >
              <AlertDialogOverlay>
              <AlertDialogContent backgroundColor= "#81C784">
              <AlertDialogHeader paddingTop={5} fontWeight="bold">
                All good!
              </AlertDialogHeader >
              <AlertDialogBody paddingBottom={5}>
                {alertMessage}<br/>
            
            </AlertDialogBody>
            </AlertDialogContent>
            </AlertDialogOverlay>

            </AlertDialog>




            <AlertDialog
            isOpen={alerterrormessage}  /* What will make it open is the alertMessage variable*/
            onClose={onClose2}
            preserveScrollBarGap
            >
              <AlertDialogOverlay>
              <AlertDialogContent backgroundColor= "#FF8A65">
              <AlertDialogHeader paddingTop={5} fontWeight="bold">
                Oops!
              </AlertDialogHeader >
              <AlertDialogBody paddingBottom={5}>
                {alerterrormessage}<br/>
            
            </AlertDialogBody>
            </AlertDialogContent>
            </AlertDialogOverlay>

            </AlertDialog>            


          
             {/*the "in" prop is what triggers or open the animation*/}
           {offlineMessage &&
          <Slide in={isOpen} >
          <Alert status="error" mt={20}>
            <AlertIcon />
            <span style={{color:"black"}}>You are offline. Please check your internet connection and try again.</span>
          </Alert> 
          </Slide>
         }
          
           
           
           {/*
            <HStack spacing={4} marginLeft="auto" marginRight={55} >
           
            <FontAwesomeIcon size="xl" icon={toggleProp? faSun: faMoon}/>
          <div className="form-check form-switch">
          <input onClick={(e)=> {
            setToggle(!toggleProp)
            setdarkAlert(!darkalert)

            setTimeout((e)=> {
              setdarkAlert(false)
            },2000)
          
          }} type="checkbox" className="form-check-input" />
          </div>
          </HStack>
        */}

        </VStack>    
    </div>
  )
}



export default ContactMeSection;
